// import logo from '../public/logo.png';
import styles from './css/App.module.css';
import Forms from './Forms';
import Header from './Header';
import Home from './Home';
import Navigation from './Navigation';
import { Route, Routes } from 'react-router-dom';
import Office from './Office';
import Photos from './Photos';
import About from './About';
import Contact from './Contact';
import ImageList from './ImageList';
import { useEffect, useState } from 'react';
import FeedDetail from './FeedDetail';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

function App() {
  const [data, setData] = useState(null)
  const location = useLocation();

  useEffect(() => {
    // Example: Extracting a title from the path
    const pathSegments = location.pathname.split('/').filter(Boolean);
    let newTitle = 'BHARATHIYA ELECTRICITY ENGINEERS ASSOCIATION'; // Default title

    if (pathSegments.length > 0) {
      const lastSegment = pathSegments[pathSegments.length - 1];
      newTitle = "BEEA - " + lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1);
      // Decode any URL encoded characters in the title
      newTitle = decodeURIComponent(newTitle);
    }
    document.title = newTitle;
  }, [location.pathname]);
  return (
    <div className={styles.app}>
      <Header />
      <Navigation />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/forms' element={<Forms />} />
        <Route path='/office' element={<Office />} />
        <Route exact path='/photos' element={<Photos />} />
        <Route path='/photos/:photoId' element={<ImageList />} />
        <Route path='/feed/:feedId/:desc' element={<FeedDetail />} />
        <Route path='/about' element={<About />} />
        <Route path='/contact' element={<Contact />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
